import { getReviews, getUserAttendance } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';

const ReviewList = () => {
    const columns = [
        {
            title: 'User Name',
            dataIndex: 'user_name',
            key: 'user_name',
            render: (_, data) => {
                return `${data?.userId?.first_name} ${data?.userId?.last_name}`
            }
        },
        {
            title: 'Agent Name',
            dataIndex: 'agent_name',
            key: 'agent_name',
            render: (_, data) => {
                return `${data?.jobId?.agent_id?.first_name} ${data?.jobId?.agent_id?.last_name}`
            }
        },
        {
            title: 'Service Name',
            dataIndex: 'service_name',
            key: 'service_name',
            render: (_, data) => {
                return data?.serviceId?.title
            }
        },
        {
            title: 'Review',
            dataIndex: 'review',
            key: 'review',
        },
        {
            title: 'Rating',
            dataIndex: 'rate',
            key: 'rate',
        },
        // {
        //     title: 'Actions',
        //     key: 'actions',
        //     render: (_, data) => (
        //         <Space>
        //             <Button onClick={() => navigate('/customer/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
        //             <Button onClick={() => navigate('/customer/view/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button>
        //             <Button onClick={() => openCustomerModal(data?._id)} icon={<DeleteOutlined />} size="small" danger>Delete</Button>
        //         </Space>
        //     ),
        // },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Reviews</h1>
            </div>
            <TableComponent
                listData={getReviews}
                columns={columns}
            />
        </div>
    );
};

export default ReviewList;

